// $FlowFixMe
import { useEffect, useRef } from 'react';
import PubSub from 'pubsub-js';
import { compact } from 'lodash';
import { useSelector } from 'react-redux';
import { projectSelector } from 'app/store/selectors/project';
import { useLocation, useParams } from 'react-router-dom';
export const documentTitle = (title, type) => {
    return PubSub.publish('DOCUMENT_TITLE', { title, type });
};
export const DocumentTitle = () => {
    var _a, _b, _c;
    const location = useLocation();
    const params = useParams();
    const project = useSelector(projectSelector);
    function getPage() {
        const splitedUrl = location.pathname.substring(1, location.pathname.length).split('/');
        if (splitedUrl[0] === 'projects') {
            if (splitedUrl[2] === 'settings') {
                if (splitedUrl[3] === 'follow-up')
                    return 'Follow-up settings';
                if (splitedUrl[3] === 'groups')
                    return 'Groups settings';
                if (splitedUrl[3] === 'steps')
                    return 'Steps settings';
            }
            if (splitedUrl[2] === 'postboard-models')
                return 'MPN';
            if (splitedUrl[2] === 'postboard-shots')
                return 'SPN';
            if (splitedUrl[2] === 'breakdown')
                return 'Breakdown';
            if (splitedUrl[2] === 'follow-up')
                return 'Follow-up';
            if (splitedUrl[2] === 'tasks')
                return 'Tasks';
            if (splitedUrl[2] === 'assets')
                return 'Assets list';
        }
        if (splitedUrl[0] === 'assets-wiki')
            return 'Wiki';
        if (splitedUrl[0] === 'my-tasks')
            return 'My tasks';
        if (splitedUrl[0] === 'my-hours')
            return 'My hours';
        if (splitedUrl[0] === 'hr') {
            if (splitedUrl[1] === 'time-recap')
                return 'Time recap';
        }
        if (splitedUrl[0] === 'admin')
            return 'Admin';
        return '';
    }
    const sub = useRef();
    const trigram = useRef();
    trigram.current = ((_b = (_a = project === null || project === void 0 ? void 0 : project.attributes) === null || _a === void 0 ? void 0 : _a.trigram) === null || _b === void 0 ? void 0 : _b.toUpperCase()) || ((_c = project === null || project === void 0 ? void 0 : project.name) === null || _c === void 0 ? void 0 : _c.toUpperCase());
    const page = useRef();
    page.current = getPage();
    function makeTitle(title) {
        const joinedTitle = compact([trigram.current, page.current, title]).join(' - ') || 'Yuzu - Asset manager';
        document.title = joinedTitle;
    }
    useEffect(() => {
        sub.current = PubSub.subscribe('DOCUMENT_TITLE', (name, { title, type }) => {
            if (type === 'page') {
                page.current = title;
                makeTitle();
            }
            else if (type === 'trigram') {
                trigram.current = title;
                makeTitle();
            }
            else
                makeTitle(title);
        });
        return () => PubSub.unsubscribe(sub.current);
    });
    useEffect(() => {
        makeTitle();
    }, [params, trigram.current]);
    return null;
};
